<template>
  <div :id="listType + '-search-bar'" class="search-plus-advance-btn flex-wrap">
    <div class="search-field mb10">
      <Search
        v-if="!showAdvancedSearch"
        v-model="searchModel.searchQuery"
        :focus="searchFocus"
        @search="onSearchSubmit"
        @clearSearch="onClearSearch"
        class="border-round-xs overflow-hidden"
        :shadow="true"
        :placeholder="$t('search...')"
        :disabled="showAdvancedSearch"
        inputClass="text-sm rp50"
      />
    </div>
    <div v-if="allowAdvancedSearch" class="advance-btn">
      <button class="btn btn-default btn-sm"
              v-on:click="() => toggleAdvancedSearch()">
        {{ showAdvancedSearch ? $t("advanced_search_back") : $t("advanced_search") }}
      </button>
    </div>
    <div v-if="allowAdd" class="add-btn">
      <button class="btn btn-carma btn-sm" v-on:click="(e) => $emit('onListAddClick', e)"><span class="fas fa-plus"></span></button>
    </div>

    <div :id="listType+'-advance-search'" class="sidebar-form" v-if="showAdvancedSearch">
      <app-form
          :id="listType+'-search-form'"
          :input-fields=fields
          :showSubmit=true
          :showCancel=true
          :submitButtonLabel="$t('form.button.search')"
          :model="searchModel"
          @onFormSubmit="onSearchSubmit"
          @updateModel="updateModel"
          @onCancelClick="toggleAdvancedSearch(false)"
      />
    </div>
  </div>
</template>

<script>
import _ from 'lodash';

import Form from '../form';
import Search from "../Search.vue";
import searchMixin from '../../mixins/search'

export default {
  props: {
    listType: String,
    fields: Object,
    allowAdd: {
      type: Boolean,
      required: true
    },
    allowAdvancedSearch: {
      type: Boolean,
      required: true
    },
    searchModel: {
      type: Object,
      default: () => { return {} }
    }
  },
  mixins: [searchMixin],
  components: {
    'app-form': Form,
    Search
  },
  methods: {
    toggleAdvancedSearch (open) {
      if(_.isUndefined(open)) {
        open = !this.showAdvancedSearch
      }
      this.updateModel({});
      this.showAdvancedSearch = open;
    },
    onSearchSubmit (value) {
      this.$set(this.searchModel, 'searchQuery', value)
      this.$emit('onSearchSubmit');
    },
    updateModel (model) {
      this.$emit('updateSearchModel', model);
    },
    onClearSearch() {
      this.$set(this.searchModel, 'searchQuery', null)
      this.$emit('onSearchSubmit');
      this.setSearchFocus()
    }
  },
  data () {
    return {
      showAdvancedSearch: false
    }
  }
}
</script>